module.exports = __webpack_public_path__ + "img/sort-numeric-up-alt.57f6679f.svg";